import { render, staticRenderFns } from "./FilterProduct.vue?vue&type=template&id=54490b83&scoped=true"
import script from "./FilterProduct.vue?vue&type=script&lang=ts"
export * from "./FilterProduct.vue?vue&type=script&lang=ts"
import style0 from "./FilterProduct.vue?vue&type=style&index=0&id=54490b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54490b83",
  null
  
)

export default component.exports